import SnackBar, { SnackbarTypes } from "components/SnackBar";

export const OfflineIndicator = () => {
  return (
    <SnackBar
      message="Not connected. Check your network."
      snackBarKey="offline"
      vertical="top"
      horizontal="center"
      openSnackBar={true}
      type={SnackbarTypes.error}
      displayInline={true}
      dimmed={true}
    />
  );
};
